/*
 * Tiny localStorage wrapper that mirrors the shape of expo-secure-store,
 * so porting auth code from the mobile app stays a one-line search/replace.
 *
 * Note: this is NOT secure. localStorage is readable by any script on the page.
 * For an MVP web companion this is acceptable; for a hardened build we'd swap
 * the access token to a memory-only var and put the refresh token in an
 * HttpOnly cookie set by the API.
 */

const PREFIX = 'gimmies18:';

export const storage = {
  getItem(key: string): string | null {
    try {
      return localStorage.getItem(PREFIX + key);
    } catch {
      return null;
    }
  },

  setItem(key: string, value: string): void {
    try {
      localStorage.setItem(PREFIX + key, value);
    } catch {
      /* swallow — quota/incognito */
    }
  },

  removeItem(key: string): void {
    try {
      localStorage.removeItem(PREFIX + key);
    } catch {
      /* swallow */
    }
  },

  /** Removes every key we own (anything namespaced under PREFIX). */
  clear(): void {
    try {
      const toRemove: string[] = [];
      for (let i = 0; i < localStorage.length; i++) {
        const k = localStorage.key(i);
        if (k && k.startsWith(PREFIX)) toRemove.push(k);
      }
      toRemove.forEach((k) => localStorage.removeItem(k));
    } catch {
      /* swallow */
    }
  },
};
